import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import * as styles from './EmptyState.module.css';
import * as textStyles from '@styles/textStyles.module.css';

const EmptyState = ({ searchTerm, children }) => {
  return (
    <div className={styles.root}>
      <div>
        <h2 className={textStyles.headlineXL}>
          No results found for “{searchTerm}”
        </h2>
        <p className={cn(styles.intro, textStyles.bodyL)}>
          We’re sorry, but your search didn’t return any results. But as we’re
          constantly growing our database of packages there is a good chance
          we’ll have the package you’re looking for soon.
        </p>
      </div>
      <div className={styles.search}>{children}</div>
    </div>
  );
};

EmptyState.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default EmptyState;
